export { DtvCompetitorTable } from "./dtv-competitor-table";
export { DtvCompetitorTableModule as default } from "./dtv-competitor-table-module";
